export default () => ({
    marginTop: '3rem',
    marginBottom: '3rem',
    '& .ImgContainer': {
        height: '5.5rem',
    },
});
